import { Briefcase, Mail, Users } from 'lucide-react';

import './InvestorList.css';

const STATUS_DOTS = {
    'Hot': 'hot',
    'Warm': 'warm',
    'Cold': 'cold',
    'In Discussion': 'info',
    'New Lead': 'neutral',
    'Contacted': 'info',
};

export function InvestorList({ investors, selectedId, onSelect, isLoading, error }) {
    if (isLoading) {
        return (
            <div className="investor-list">
                <div className="list-state">
                    <span className="spinner" />
                    <span>Loading investors…</span>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="investor-list">
                <div className="list-state list-state-error">
                    <strong>Couldn't load investors</strong>
                    <span>{error.message}</span>
                </div>
            </div>
        );
    }

    if (investors.length === 0) {
        return (
            <div className="investor-list">
                <div className="list-state">
                    <strong>No investors match these filters</strong>
                    <span>Try clearing some filters or searching differently.</span>
                </div>
            </div>
        );
    }

    return (
        <div className="investor-list">
            {investors.map(inv => {
                const isSelected = inv.id === selectedId;
                const dot = STATUS_DOTS[inv.status] || 'neutral';
                const hasExtraContacts = (inv.contact_count || 0) > 1;
                return (
                    <button
                        key={inv.id}
                        onClick={() => onSelect(inv.id)}
                        className={`investor-card${isSelected ? ' is-selected' : ''}`}
                    >
                        <div className="investor-card-row">
                            <span className="investor-name">{inv.name}</span>
                            {inv.fit_level && (
                                <span className={`fit-badge fit-${inv.fit_level.toLowerCase().replace(' ', '-')}`}>
                                    {inv.fit_level}
                                </span>
                            )}
                        </div>

                        {inv.primary_contact_name && (
                            <div className="investor-meta">
                                <span className="investor-contact">{inv.primary_contact_name}</span>
                                {hasExtraContacts && (
                                    <span className="contact-count" title={`${inv.contact_count} contacts at this fund`}>
                                        <Users size={10} strokeWidth={1.75} />
                                        +{inv.contact_count - 1}
                                    </span>
                                )}
                            </div>
                        )}

                        <div className="investor-card-row investor-card-footer">
                            <div className="investor-tags">
                                {inv.status && (
                                    <span className="status-pill">
                                        <span className={`status-dot dot-${dot}`} />
                                        {inv.status}
                                    </span>
                                )}
                                {inv.assign_to_startups && (
                                    <span className="startup-tag" title={inv.assign_to_startups}>
                                        <Briefcase size={11} strokeWidth={1.75} />
                                        {firstStartup(inv.assign_to_startups)}
                                    </span>
                                )}
                            </div>
                            {inv.primary_contact_email && (
                                <Mail size={12} strokeWidth={1.5} className="investor-icon" />
                            )}
                        </div>
                    </button>
                );
            })}
        </div>
    );
}

function firstStartup(s) {
    const first = s.split(',')[0].trim();
    return first.length > 18 ? first.slice(0, 17) + '…' : first;
}
